const memoryStorageTTLInMinutes = 5;
export const queryServicesEndpointConfiguration = {
  url: '/_api/bookings/v2/services/query',
  method: 'POST',
  memoryStorageTTLInMinutes,
  requestToCacheKey: _ref => {
    var _body$query, _filter$id;
    let {
      method,
      url,
      body
    } = _ref;
    const filter = body == null || (_body$query = body.query) == null ? void 0 : _body$query.filter;
    const serviceSlug = filter == null ? void 0 : filter['supportedSlugs.name'];
    const serviceIds = filter == null || (_filter$id = filter.id) == null ? void 0 : _filter$id.$in;
    if (serviceSlug) {
      return buildCacheKey({
        serviceSlug
      });
    }
    if ((serviceIds == null ? void 0 : serviceIds.length) === 1) {
      const serviceId = serviceIds[0];
      return buildCacheKey({
        serviceId
      });
    }
    return [method, url, JSON.stringify(body)];
  },
  onResponse: _ref2 => {
    var _response$data$servic;
    let {
      response,
      bookingsViewerStorageManager
    } = _ref2;
    (_response$data$servic = response.data.services) == null || _response$data$servic.forEach(service => {
      var _service$mainSlug;
      const serviceIdCacheKey = buildCacheKey({
        serviceId: service.id
      });
      const serviceSlugCacheKey = buildCacheKey({
        serviceSlug: (_service$mainSlug = service.mainSlug) == null ? void 0 : _service$mainSlug.name
      });
      const responseWithService = {
        ...response,
        data: {
          ...response.data,
          services: [service],
          pagingMetadata: {
            ...response.data.pagingMetadata,
            count: 1
          }
        }
      };
      bookingsViewerStorageManager.set(serviceIdCacheKey, responseWithService, memoryStorageTTLInMinutes);
      bookingsViewerStorageManager.set(serviceSlugCacheKey, responseWithService, memoryStorageTTLInMinutes);
    });
  }
};
const buildCacheKey = _ref3 => {
  let {
    payload,
    serviceId,
    serviceSlug
  } = _ref3;
  const cacheKey = ['queryServices'];
  if (payload) {
    cacheKey.push(JSON.stringify(payload));
  } else if (serviceId) {
    cacheKey.push('id', serviceId);
  } else if (serviceSlug) {
    cacheKey.push('slug', serviceSlug);
  }
  return cacheKey;
};
//# sourceMappingURL=queryServices.js.map